import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export default function useJobCooldown(kittyId) {
  const cooldownQuery = useQuery({
    queryKey: ['job-cooldown', kittyId],
    queryFn: async () => {
      const { data } = await axios.post('/api/jobs/check-cooldown', {
        kittyId,
      });
      return data;
    },
    enabled: !!kittyId,
    refetchInterval: 60000, // Check every minute
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: false,
    retry: false,
  });

  const { data: cooldown, isLoading: loading } = cooldownQuery;

  return { cooldown, loading, cooldownQuery };
}
